<template>
    <div>
        <vue-headful
            v-if="requestData.name"
            :title="`${requestData.name} - ${$t('stud-clubs')}`"
        />
        <vue-headful v-else :title="$t('stud-clubs')" />
        <div id="profile-page">
            <!-- Шапка -->

            <div>
                <vs-card>
                    <div slot="media">
                        <img
                            :src="
                                requestData.club_logo !== undefined
                                    ? requestData.club_logo.path
                                    : ''
                            "
                            alt="user-profile-cover"
                            class="responsive block"
                            style="
                                height: 200px;
                                object-fit: cover;
                                border-top-left-radius: 7px;
                                border-top-right-radius: 7px;
                            "
                        />
                    </div>
                    <!-- Вступить в клуб редактирование клуба -->
                    <div class="lg:flex justify-between">
                        <h2 class="mb-2 lg:mb-0">{{ requestData.name }}</h2>
                        <div class="flex lg:block">
                            <vs-button
                                v-if="!isStudent"
                                :disabled="disableJoinClub"
                                @click="dialogJoin = true"
                                icon="add"
                                >{{
                                    disableJoinClub
                                        ? $t("request_posted")
                                        : $t("join_club")
                                }}</vs-button
                            >
                            <vs-button
                                v-if="isStudent && !isFounder"
                                @click="leaveStudent"
                                icon="exit_to_app"
                                >{{ $t("exit_club") }}</vs-button
                            >

                            <div>
                                <div v-if="!requestData.has_request">
                                    <vs-button
                                        v-if="isFounder"
                                        icon="edit"
                                        @click="goToEdit"
                                        >{{ $t("edit_club") }}</vs-button
                                    >
                                </div>

                                <vs-alert :title="$t('remark')" active="true" color="warning" class="mt-4" v-else>
                                    {{ $t('remark_for_not_edit') }}
                                </vs-alert>
                            </div>
                        </div>
                    </div>
                </vs-card>
            </div>
        </div>

        <div class="vx-row">
            <!-- COL 1 -->
            <div class="vx-col w-full flex_basis lg:w-1/4">
                <!-- Описание клуба -->
                <vx-card :title="$t('about_me')" class="mt-1 lg:mt-base">
                    <div class="user-bio -mt-4">
                        <p>
                            {{ requestData.description }}
                        </p>
                    </div>

                    <!-- Тип клуба -->

                    <div class="mt-5">
                        <h6>{{ $t("type_club") }}:</h6>
                        <span>{{
                            requestData.club_type !== undefined
                                ? requestData.club_type.name
                                : ""
                        }}</span>
                    </div>
                    <!-- Статус -->
                    <div class="mt-5">
                        <h6>{{ $t("status") }}:</h6>
                        <span>{{
                            requestData.public_or_private
                                ? $t("closed1")
                                : $t("public")
                        }}</span>
                    </div>
                    <!-- Факультеты -->
                    <div
                        class="mt-5"
                        v-if="
                            requestData.faculti !== undefined &&
                            requestData.faculti.length > 0
                        "
                    >
                        <h6>{{ $t("faculty") }}:</h6>
                        <span>{{ requestData.faculti }}</span>
                    </div>
                    <!-- Дата основания -->
                    <div class="mt-5">
                        <h6>{{ $t("date_create") }}:</h6>
                        <span>{{
                            $moment(requestData.created).format("DD.MM.YYYY")
                        }}</span>
                    </div>
                    <!-- Соц сети -->
                    <div
                        v-if="requestData.social_links.length > 0"
                        class="social-links flex-column mt-4"
                    >
                        <h6>{{ $t("social_links") }}:</h6>
                        <div
                            v-for="link in requestData.social_links"
                            :key="link.uid"
                            class="flex"
                        >
                            <a
                                class="mt-1"
                                target="_blank"
                                :href="link.social_link"
                                >{{ link.social_web_type.name }}</a
                            >
                        </div>
                    </div>
                </vx-card>
                <!-- События  клуба-->
                <vx-card
                    v-if="allEvents.length > 0"
                    :title="$t('events_club')"
                    class="mt-6 lg:mt-base"
                >
                    <div v-for="item in allEvents" :key="item.uid">
                        <div class="flex justify-between items-center">
                            <!-- Название и место события -->
                            <div class="flex-col flex">
                                <span class="text-xl">{{ item.name }}</span>
                                <span v-if="item.event_place !== 'False'">{{
                                    item.event_place
                                }}</span>
                            </div>
                            <!-- Дата события -->
                            <div class="flex items-center">
                                <span class="text-xl font-bold">{{
                                    $moment(item.event_start).format("D.M H:mm")
                                }}</span>
                                <div
                                    v-if="isFounder"
                                    class="ml-2 cursor-pointer"
                                >
                                    <vx-tooltip
                                        :text="$t('remove_event')"
                                        position="right"
                                    >
                                        <vs-button
                                            @click="deleteEvent(item)"
                                            radius
                                            size="small"
                                            type="border"
                                            icon="clear"
                                        />
                                    </vx-tooltip>
                                </div>
                            </div>
                        </div>
                        <vs-divider></vs-divider>
                    </div>
                </vx-card>

                <!-- Галерея -->
                <vx-card
                    v-if="isStudent"
                    :title="$t('club_gallery')"
                    class="mt-6 lg:mt-base"
                >
                    <div v-if="galeryImages.length > 0" class="vx-row pt-2">
                        <div
                            class="vx-col w-1/2 sm:w-1/2 md:w-1/3 xl:1/4"
                            v-for="(img, index) in galeryImages"
                            :key="index"
                        >
                            <div v-if="index < 9">
                                <img
                                    :src="img.path"
                                    :alt="img.name"
                                    style="
                                        max-height: 50px;
                                        object-fit: contain;
                                        cursor: pointer;
                                    "
                                    @click="activeGalery = true"
                                    class="rounded mb-4 user-latest-image responsive"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="flex items-center -mt-2" v-else>
                        <span>{{ $t("image_not_found") }}</span>
                    </div>
                    <vs-button
                        v-if="isFounder"
                        class="mt-6 w-full"
                        @click="activeAddGalery = true"
                    >
                        {{ $t("add_image") }}
                    </vs-button>
                </vx-card>
            </div>

            <vs-popup
                :title="$t('club_gallery')"
                fullscreen
                :active.sync="activeGalery"
            >
                <div style="height: 84vh">
                    <!-- swiper1 -->
                    <swiper
                        :options="swiperOptionTop"
                        class="gallery-top"
                        ref="swiperTop"
                    >
                        <swiper-slide
                            v-for="item in galeryImages"
                            :key="item.uid"
                        >
                            <vs-button
                              v-if="isFounder"
                                @click="deleteImageInGalery(item)"
                                icon="delete"
                                size="small"
                                ></vs-button
                            >
                            <img
                                class="responsive"
                                style="max-height: 80vh; object-fit: contain"
                                :src="item.path"
                                :alt="item.name"
                            />
                        </swiper-slide>

                        <div
                            class="swiper-button-next swiper-button-white"
                            slot="button-next"
                        ></div>
                        <div
                            class="swiper-button-prev swiper-button-white"
                            slot="button-prev"
                        ></div>
                    </swiper>

                    <!-- swiper2 Thumbs -->
                    <swiper
                        :options="swiperOptionThumbs"
                        class="gallery-thumbs"
                        ref="swiperThumbs"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :key="$vs.rtl"
                    >
                        <swiper-slide
                            v-for="item in galeryImages"
                            :key="item.uid"
                        >
                            <img
                                class="responsive"
                                :src="item.path"
                                :alt="item.name"
                            />
                        </swiper-slide>
                    </swiper>
                </div>
            </vs-popup>

            <vs-popup :title="$t('add_image')" :active.sync="activeAddGalery">
                <div>
                    <vs-upload
                        v-if="trueUpload"
                        :action="'common/upload/'"
                        @on-success="setImageGalery"
                        @prev-delete="removeFileGalery"
                        :max-size="10"
                        automatic
                        multiple
                        :text="$t('select_a_file')"
                        :fileName="'path'"
                    />

                    <vs-button color="primary" @click="postImageGalery">
                        {{ $t("add_image") }}
                    </vs-button>
                </div>
            </vs-popup>

            <!-- КОЛОНКА по середине -->
            <!-- Кнопка создать публикацию -->
            <div class="vx-col w-full lg:w-1/2 flex_order">
                <vs-button
                    v-if="isFounder"
                    class="w-full mt-5 lg:mt-10 lg:-mb-4"
                    icon="add"
                    @click="openPopup('news','clear')"
                    >{{ $t("create_post") }}
                </vs-button>
                <vx-card
                    v-if="
                        (!isStudent &&
                            !requestData.public_or_private &&
                            userPosts.length === 0) ||
                        (isStudent && userPosts.length === 0)
                    "
                    class="mt-6 lg:mt-base"
                >
                    <h6>{{ $t("news_not_found") }}</h6>
                </vx-card>
                <!-- Заглужка для не участников клуба -->
                <vx-card
                    class="mt-6 lg:mt-base"
                    v-if="!isStudent && requestData.public_or_private"
                >
                    <h6>
                        {{ $t("no_partisipants_club") }}
                    </h6>
                </vx-card>

                <!-- Новости -->
                <template v-else>
                    <vx-card  class="mt-6 lg:mt-base" v-for="post in userPosts" :key="post.uid" :id="post.uid">
                        <NewsCard v-if="!post.is_event" :post="post" :isFounder="isFounder" v-on:openEditPopup="openPopup($event)"/>
                        <EventCard v-else :post="post" :isFounder="isFounder" v-on:openEditPopup="openPopup($event)" v-on:closePopup="fetchUpdateNews"/>
                    </vx-card>
                </template>

            </div>

            <!-- COL 3 -->
            <div class="vx-col w-full flex_basis lg:w-1/4">
                <!-- Заявки на вступления только для админа -->
                <friend-suggestion :isFounder="isFounder"/>
                <!-- Участники клуба -->
                <Partisipants :isFounder="isFounder" :isStudent="isStudent" v-on:openModalInvite="modalInvite = true" :allRoles="allRoles"/>
            </div>
        </div>
        <!-- Модалка пригласить друга -->
        <vs-popup :title="$t('invite_student')" :active.sync="modalInvite">
            <div>
                <multiselect
                    v-model="selectedInvite"
                    id="ajax"
                    label="fullname"
                    track-by="uid"
                    :placeholder="$t('not_found')"
                    open-direction="bottom"
                    :options="inviteItems"
                    :multiple="true"
                    deselectLabel=""
                    selectLabel=""
                    :searchable="true"
                    :loading="loadingInvite"
                    :internal-search="false"
                    :clear-on-select="false"
                    :close-on-select="false"
                    :max-height="600"
                    :show-no-results="false"
                    :hide-selected="true"
                    @search-change="asyncFind"
                >
                    <template slot="tag" slot-scope="{ option, remove }"
                        ><span class="custom__tag"
                            ><span>{{ option.fullname }}</span
                            ><span
                                class="custom__remove"
                                style="cursor: pointer"
                                @click="remove(option)"
                                ><vs-icon>clear</vs-icon></span
                            ></span
                        ></template
                    >

                    <div slot="noOptions">{{ $t("no_data") }}</div>
                    <div slot="noResult">{{ $t("not_search_result") }}</div>
                </multiselect>

                <vs-button
                    @click="postInvite"
                    icon="person_add"
                    class="mt-4 w-full"
                    >{{ $t("invite") }}</vs-button
                >
            </div>
        </vs-popup>

        <!-- Загрузить еще новости -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="flex justify-center mt-base">
                    <vs-button
                        v-show="moreNews"
                        id="button-load-more-posts"
                        class="vs-con-loading__container"
                        @click="getMoreNews"
                        >{{ $t("upload_more") }}</vs-button
                    >
                </div>
            </div>
        </div>
        <!-- Модалка создания новости и события -->
        <vs-popup :title="$t('create_post')" :active.sync="activeNewPost" class="overflow-y-auto">
            <vs-tabs v-model="activeTab">
                <!-- Создание новости -->
                <vs-tab :label="$t('news_one')">
                    <!--  <TabsNews :updateNews="updateNewsData"/> -->
                    <TabsNews v-on:closePopup="fetchUpdateNews"/>
                </vs-tab>
                <!-- Создание события -->
                <vs-tab :label="$t('event')">
                    <TabsEvent  v-on:closePopup="fetchUpdateNews" :config="configStartDateTimePicker" />
                </vs-tab>

            </vs-tabs>
        </vs-popup>
        <!-- Модалка вступления в клуб -->
        <vs-prompt
            :title="$t('join_club')"
            :buttons-hidden="true"
            :accept-text="$t('post_request')"
            :active.sync="dialogJoin"
        >
            <vs-checkbox class="" v-model="joinParamsCheckBox">{{
                $t("view_my_in_student")
            }}</vs-checkbox>
            <div class="flex justify-center mt-4">
                <vs-button @click="join">{{ $t("post_request") }}</vs-button>
            </div>
        </vs-prompt>
        <div class="mobile_dummy"></div>
    </div>
</template>

<script>
import Profile from "@/widgets/Profile";
import Comment from "@/widgets/CommentBox/Comment";
import { Russian } from "flatpickr/dist/l10n/ru";
import { Kazakh } from "flatpickr/dist/l10n/kz";
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";
import debounce from "lodash.debounce";
import NewsCard from "@/pages/Home/StudClubs/components/NewsCard";
import EventCard from "@/pages/Home/StudClubs/components/EventCard";
import TabsEvent from "@/pages/Home/StudClubs/components/TabsEvent";
import TabsNews from "@/pages/Home/StudClubs/components/TabsNews";
import FriendSuggestion from "@/pages/Home/StudClubs/components/FriendSuggestion";
import Partisipants from "@/pages/Home/StudClubs/components/Partisipants";

export default {
    components: {
        Profile,
        Comment,
        swiper,
        swiperSlide,
        NewsCard,
        EventCard,
        TabsEvent,
        TabsNews,
        FriendSuggestion,
        Partisipants
    },

    data() {
        return {
            activeNewPost: false,
            activeTab: 0,
            dataNewNews: {
                title: "",
                content: null,
                image: null,
                student_club: "",
            },
            trueUpload: true,
            files: [],
            requestData: { social_links: [] },
            joinParamsCheckBox: false,
            dialogJoin: false,
            disableJoinClub: false,
            roles: [],
            configStartDateTimePicker: {
                time_24hr: true,
                allowInput: true,
                altInput: true,
                enableTime: true,
                altFormat: "d.m.Y H:i",
                dateFormat: "Y-m-dTH:i:S+06:00",
                // locale: this.$i18n.locale === "kk" ? "kz" : this.$i18n.locale,
                minDate: new Date(),
            },

            userPosts: [],
            pageNews: 1,
            moreNews: false,
            isStudent: false,
            isFounder: false,

            inviteItems: [],
            selectedInvite: [],
            loadingInvite: false,

            allEvents: [],
            modalInvite: false,
            // Галерея
            uploadImages: [],
            galeryImages: [],
            filesGalery: [],
            activeGalery: false,
            activeAddGalery: false,
            updateNews: false,
            allRoles: [],

            swiperOptionTop: {
                spaceBetween: 10,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },
            swiperOptionThumbs: {
                spaceBetween: 10,
                centeredSlides: true,
                slidesPerView: "auto",
                touchRatio: 0.2,
                slideToClickedSlide: true,
            },

            updateEventData:{
                uid:"",
                is_update:false,
            },
            updateNewsData:{
                uid:"",
                is_update:false,
            },
        };
    },

    watch:{
        activeNewPost(val){
            if(!val){
                this.$store.dispatch('studclubs/clearPopupData');
            }
        }
    },
    computed: {
        uid() {
            return this.$route.query.uid;
        },

        ...mapGetters({
            USER: "user/getUser",
        }),
    },
    mounted() {
        this.$nextTick(() => {
            const swiperTop = this.$refs.swiperTop.swiper;
            const swiperThumbs = this.$refs.swiperThumbs.swiper;
            swiperTop.controller.control = swiperThumbs;
            swiperThumbs.controller.control = swiperTop;
        });
    },
    async created() {
        this.$vs.loading();
        // Проврека есть ли uid в url
        if (this.uid !== undefined) {
            // Получени сонвной ифномрации о клубе
            const res = await this.$http(
                `student_clubs/my_student_clubs/${ this.uid }/`
            );

            this.requestData = {
                director: res.data.student_club_members
                    .map((el) => {
                        return el.student_full_name;
                    })
                    .toString(),
                faculti: res.data.faculty
                    .map(function (el) {
                        return el.name;
                    })
                    .toString(),
                ...res.data,
            };
            await this.getRoles();
            this.getAllRoles();
            this.getAllNews();
            this.getGalery();
            if(this.requestData.public_or_private){
                if(this.isStudent || this.isFounder){
                    this.getClubEvents();
                }
            }else {
                this.getClubEvents();
            }



            // Роли
        } else {
            this.$router.push({ name: "stud-clubs" });
        }
        this.$vs.loading.close();
    },
    methods: {
        //
        async getAllRoles(){
            const res = await this.$http(
                `student_clubs/student_club_membership_role/`
            );
            if (res.status === 200) {
                this.allRoles = res.data;
            }
        },

        // Получение ролей
        async getRoles() {
            this.$vs.loading();
            const res = await this.$http(
                `student_clubs/my_student_clubs/${ this.uid }/my_role/`
            );
            if (res.data[0].uid) {
                this.roles = res.data;
                res.data.forEach((item) => {
                    if (
                        item.student_profile.profileId === this.USER.profileId
                    ) {
                        if (
                            item.membership_role.code === "FOUNDER"
                        ) {
                            this.isFounder = true;
                            this.isStudent = true;
                        } else if (
                            item.membership_role.code === "MEMBER"

                        ) {
                            this.isStudent = true;
                        } else if (
                            item.membership_role.code === "MODERATOR"

                        ) {
                            this.isFounder = true;
                            this.isStudent = true;
                        }
                    }
                });

                // Если участник то получаем все новости и события
            }
            this.$vs.loading.close();
        },

        // Поиск друга
        asyncFind: debounce(async function (name) {
            if (!this.loadingInvite && name !== "" && name.length > 1) {
                this.loadingInvite = true;
                const res = await this.$http(`/user/search/`, {
                    params: {
                        fullname: name,
                        page_size: 200,
                    },
                });
                this.inviteItems = res.data.results;

                this.loadingInvite = false;
            }
        }, 500),

        async postInvite() {
            const data = this.selectedInvite.map((item) => item.uid);
            const res = await this.$http.post(
                `/student_clubs/my_student_clubs/${ this.uid }/send_invitations/`,
                { profile_uid: data }
            );
            if (res.status === 200) {
                this.$vs.notify({
                    title: this.$t("succesful"),
                    color: "primary",
                });
                this.modalInvite = false;
                this.selectedInvite = [];
            }
        },

        // Добавление изображений галереии
        async postImageGalery() {
            this.$vs.loading();
            const res = await this.$http.put(
                `/student_clubs/my_student_clubs/${ this.uid }/upload_gallery_files/`,
                { files: this.uploadImages }
            );
            if (res.status === 200) {
                this.galeryImages = res.data.gallery_files;
                this.$vs.notify({
                    title: this.$t("succesful"),
                    text: this.$t("image_added"),
                    color: "primary",
                });
                this.trueUpload = false;
                setTimeout(() => {
                    this.trueUpload = true;
                }, 300);
                this.activeAddGalery = false;
            }
            this.$vs.loading.close();
        },
        async getGalery() {
            this.$vs.loading();
            const res = await this.$http(
                `/student_clubs/my_student_clubs/${ this.uid }/get_gallery_files/`
            );
            if (res.status === 200) {
                this.galeryImages = res.data.gallery_files;
            }
            this.$vs.loading.close();
        },
        async deleteImageInGalery(item) {
            this.$vs.loading();
            let files = [item.uid];
            const res = await this.$http.delete(
                `/student_clubs/my_student_clubs/${ this.uid }/delete_gallery_files/`,
                { data: { files } }
            );
            if (res.status === 200) {
                this.galeryImages = res.data.gallery_files;
                this.$vs.notify({
                    title: this.$t("succesful"),
                    text: this.$t("deleted"),
                    color: "primary",
                });
            }
            this.$vs.loading.close();
        },



        async fetchUpdateNews(){
            this.$vs.loading();

            this.userPosts = [],
            await this.getAllNews()

            this.activeNewPost = false;
            this.$vs.loading.close();
        },

        // Метод для пагинации новостей
        async getMoreNews() {
            this.$vs.loading({
                container: "#button-load-more-posts",
                scale: 0.45,
            });

            this.pageNews += 1;
            await this.getAllNews();

            this.$store.dispatch('studclubs/clearPopupData');

            this.$vs.loading.close("#button-load-more-posts > .con-vs-loading");
        },




        // Поулчение всех новостей
        async getAllNews() {
            this.$vs.loading();
            // const res = await this.$http.get(`/student_clubs/news/`, {
            //     params: { page: this.pageNews, student_club: this.uid },
            // });
            const res = await this.$http.get(`/student_clubs/news_and_events/`, {
                params: { page: this.pageNews, student_club: this.uid },
            });
            res.data.results.forEach((el) => {
                this.userPosts.push(el);
            });

            if (res.data.next === null) {
                this.moreNews = false;
            } else {
                this.moreNews = true;
            }
            this.$vs.loading.close();
        },

        async openPopup(data,commit){

            if(data.type === 'news' || !data){//по умолчанию открыть новостную модал
                this.activeTab = 0;
            }
            if(data.type === 'event'){
                this.activeTab = 1;
            }

            if(commit == 'clear'){
                 this.activeTab = 0;
                this.$store.dispatch('studclubs/clearPopupData');
            }

            this.activeNewPost = true;
        },

        // Выйти из клуба
        async leaveStudent() {
            const res = await this.$http.delete(
                `student_clubs/my_student_clubs/${ this.uid }/leave_student_club/`
            );
            if (res.status === 200) {
                this.$vs.notify({
                    title: this.$t("succesful"),
                    text: this.$t("we_exit_club"),
                    color: "primary",
                });
                this.isStudent = false;
            }
        },



        // Удалить событие
        async deleteEvent(item) {
            const res = await this.$http.delete(
                `student_clubs/events/${ item.uid }/`,
                {
                    data: {
                        student_club: this.uid,
                    },
                }
            );
            if (res.status === 204) {
                this.allEvents = this.allEvents.filter(
                    (el) => el.uid !== item.uid
                );
                this.$vs.notify({
                    title: this.$t("succesful"),
                    text: this.$t("event_deleted"),
                    color: "primary",
                });
            }
        },

        // Поулчение всех событий
        async getClubEvents() {
            const res = await this.$http(
                `student_clubs/events/?student_club=${ this.uid }`
            );
            if (res.status === 200) {
                this.allEvents = res.data;
            }
        },

        // Заявка на вступление в клуб
        async join() {
            this.$vs.loading();
            const res = await this.$http.post(
                `student_clubs/my_student_clubs/${ this.requestData.uid }/join_student_club/`,
                {
                    member_visible: this.joinParamsCheckBox,
                }
            );
            if (res.status === 200) {
                this.$vs.notify({
                    title: this.$t("succesful"),
                    text: this.$t("request_posted"),
                    color: "success",
                });
                this.dialogJoin = false;
                this.disableJoinClub = true;
            }

            this.$vs.loading.close();
        },


        // Удаление файла для нвостей
        async removeFile({ file, done }) {
            this.files = await this.files.filter(
                (item) => item.response.uid !== file.response.uid
            );
            done();
        },
        async removeFileGalery({ file, done }) {
            this.uploadImages = await this.uploadImages.filter(
                (item) => item.response.uid !== file.response.uid
            );
            done();
        },


        setImageGalery(response) {
            // this.dataNewNews.image = response[0].uid;
            // console.log("resposne IMages", response);
            this.uploadImages = []
            response.forEach((item) => {
                this.uploadImages.push(item.uid);
            });
        },

        // Кнопка редактировать клуб
        goToEdit() {
            this.$router.push({
                name: "stud-clubs-create",
                query: { uid: this.uid },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 800px) {
    .flex_basis {
        flex-basis: auto;
    }
    .flex_order {
        order: 1;
    }
    .mobile_dummy {
        padding-top: 30px;
    }
}
.swiper-container {
    background-color: gray;
}
.gallery-top {
    height: 80% !important;
    width: 100%;
}
.gallery-thumbs {
    height: 20% !important;
    box-sizing: border-box;
    padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
    opacity: 1;
}
</style>
<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";
@media only screen and (min-width: 900px) {
    #profile-page {
        .con-vs-card .vs-card--content,
        .con-vs-card {
            margin-bottom: 0px;
        }
    }
}
.vs-popup {
    width: 960px !important;
}
.vs-popup--content {
    // overflow: inherit;
}
.quill-editor {
    .vs-icon {
        font-size: 18px;
    }
    #toolbar {
        position: sticky;
        top: -15px;
        z-index: 5555;
        background: #ffffff;
    }
    .ql-edit-html-textarea {
        width: 100%;
        background: rgb(29, 29, 29);
        color: rgb(204, 204, 204);
        outline: none;
        padding: 12px 15px;
        font-family: Consolas;
        position: absolute;
        top: 0;
        bottom: 0;
        border: none;
    }
}
</style>
